<script setup lang="ts">
import { Vue3Lottie } from 'vue3-lottie'

import confettiJson from './confetti.json'
import checkmarkJson from './checkmark.json'
import type { PartnerParameter, Tablet } from '@/types/types'

withDefaults(
  defineProps<{
    partnerParameter: PartnerParameter
    tablet: Tablet
  }>(),
  {
    partnerParameter: null,
    tablet: null
  }
)
const { t } = useI18n()
const emit = defineEmits(['on-button-click'])
const imgUrl = `${import.meta.env.VITE_AWS_STORAGE_URL}/empty-state/tablet-modale.png`
</script>

<template>
  <Vue3Lottie
    :loop="3"
    :animation-data="confettiJson"
    class="confetti absolute inset-0 hidden h-full w-full sm:block"
  />

  <div class="d-flex z-9 relative flex-col">
    <div class="my-16 flex grid-cols-3 items-center justify-center px-20 sm:grid">
      <div class="flex flex-col items-end justify-center">
        <div class="relative flex">
          <div class="flex h-16 w-16 items-center justify-center rounded-full border-2 border-primary bg-primary/5 p-3">
            <img :src="partnerParameter.partner.logo" />
          </div>
        </div>
      </div>
      <div class="hidden items-center justify-center sm:flex">
        <div class="relative w-full">
          <div class="absolute top-1/2 z-0 w-full border-t border-dashed border-border" />
          <div
            class="absolute left-1/2 top-1/2 z-10 flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 transform items-center justify-center rounded-full bg-white p-1"
          >
            <Vue3Lottie
              :loop="false"
              :animation-data="checkmarkJson"
              :speed="0.8"
              class="absolute inset-0 hidden h-full w-full sm:block"
            />
          </div>
        </div>
      </div>
      <div class="hidden flex-col items-start justify-center sm:flex">
        <div class="relative flex">
          <div class="flex h-16 w-16 items-center justify-center rounded-full border-2 border-primary bg-primary/5 p-0">
            <img class="rounded-full" :src="imgUrl" />
          </div>
        </div>
      </div>
    </div>
    <h1 class="text-medium mb-5 font-semibold text-foreground">{{ t('pages.tablet.modal.success') }}</h1>
    <div class="text-sm text-foreground">
      <p class="mb-3">
        {{ t('pages.tablet.modal.description.first') }}
        <span class="font-semibold text-foreground">{{ partnerParameter.partner.name }}</span>
      </p>
    </div>
    <Button variant="default-primary" class="mt-10" @click="emit('on-button-click')">
      {{ t('pages.tablet.modal.start') }}
    </Button>
  </div>
</template>

<style scoped>
.confetti {
  z-index: 1 !important;
}
.z-9 {
  z-index: 9 !important;
}
</style>
